<template>
  <div class="pb-0 mb-0">
    <v-btn small class="ma-0" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn
    >
    <h4 class="text-primary text-center mt-0 pt-0 mb-0">REPORTE RECAUDACIÓN TOTAL CORPORACION.</h4>
    <p class="text-center blue--text">El convenio no afecta a este reporte.</p>

    <v-row dense class="ml-2">
      <v-col cols="2">
        <v-combobox
          v-model="filtros.gestion"
          :items="gestiones"
          label="Gestion"
          :disabled="loading"
          hide-details
          outlined
          dense></v-combobox>
      </v-col>
      <v-col cols="2">
        <v-combobox
          v-model="filtros.mes"
          :items="meses"
          label="Mes"
          :disabled="loading"
          hide-details
          outlined
          dense></v-combobox>
      </v-col>
      <!-- <v-col cols="2">
        <v-combobox
          v-if="$store.state.CARGO.id != 15 && $store.state.CARGO.id != 3"
          v-model="filtros.unidad"
          :items="unidades"
          label="Sede"
          :disabled="loadingunidades || loading"
          :loading="loadingunidades"
          hide-details
          outlined
          dense></v-combobox>
        <span v-else-if="filtros.unidad" class="mt-2 pt-2">
          {{ filtros.unidad.nombre }}
        </span>
      </v-col> -->
      <v-col cols="3">
        <v-switch
          v-model="omit_filtro"
          :disabled="loading"
          label="Mostrar total"
          dense
          hide-details
          title="Omitir el filtro por convenio y mostrar todo."
          class="mb-4"></v-switch>
      </v-col>
    </v-row>

    <p class="text-center text-danger pa-0" v-if="msg">
      <b>{{ msg }}</b>
    </p>
    <v-progress-linear indeterminate v-if="loading" class="mt-2" />

    <div><AAsignacionTablaRtxs ref="asignacionestablar" v-on:dataloaded="dataloaded" /></div>
  </div>
</template>

<script>
  import AAsignacionTablaRtxs from '@/components/AAsignacionTablaCor.vue';

  export default {
    data() {
      return {
        msg: '',
        loading: false,
        loadingunidades: false,
        gestiones: [2024,2023, 2022, 2021, 2020, 2019, 2018],
        meses: [
          { id: 1, text: 'Enero' },
          { id: 2, text: 'Febrero' },
          { id: 3, text: 'Marzo' },
          { id: 4, text: 'Abril' },
          { id: 5, text: 'Mayo' },
          { id: 6, text: 'Junio' },
          { id: 7, text: 'Julio' },
          { id: 8, text: 'Agosto' },
          { id: 9, text: 'Septiembre' },
          { id: 10, text: 'Octubre' },
          { id: 11, text: 'Noviembre' },
          { id: 12, text: 'Diciembre' },
        ],
        unidades: [],
        filtros: {
          gestion: null,
          mes: null,
          unidad: null,
        },
        omit_filtro: false,
      };
    },
    components: { AAsignacionTablaRtxs },
    watch: {
      'filtros.gestion': function () {
        if (this.filtros.gestion) this.listarsignaciones();
      },
      'filtros.mes': function () {
        if (this.filtros.mes) this.listarsignaciones();
      },
      'filtros.unidad': function () {
        if (this.filtros.unidad) this.listarsignaciones();
      },
      omit_filtro: function () {
        this.listarsignaciones();
      },
      '$store.state.convenio': function () {
        if (this.$store.state.convenio) {
          this.listarsignaciones();
        }
      },
    },
    methods: {
      listarsignaciones() {
        if (!this.filtros.gestion) return;
        if (!this.filtros.mes) return;
        //if (!this.filtros.unidad) return;
        let anio = this.filtros.gestion;
        let mes = this.filtros.mes.id;
        //let unidad = this.filtros.unidad.id;
        if (this.loading) return;
        this.loading = true;
        let convenio = 0;
        if (this.$store.state.convenio && !this.omit_filtro) convenio = this.$store.state.convenio.id;
        this.$refs.asignacionestablar.obtenerasignaciones(mes, anio, 1, convenio);
      },
      defaultdata() {
        let date = new Date();
        let anio = date.getFullYear();
        let mes = date.getMonth() + 1;
        this.filtros.gestion = '' + anio;
        this.filtros.mes = this.meses.find((x) => x.id == mes);
      },
      dataloaded() {
        this.loading = false;
      },
    },
    mounted() {
      this.defaultdata();
    },
  };
</script>
